import heroImage from "../../assets/senca/hero.jpg";
import aboutImage from "../../assets/senca/about.jpg";
import project1 from "../../assets/senca/project-1.jpg";
import project2 from "../../assets/senca/project-2.jpg";
import project3 from "../../assets/senca/project-3.jpg";
import project4 from "../../assets/senca/project-4.jpg";
import socialInstagram from "../../assets/senca/social-instagram.png";
import socialFacebook from "../../assets/senca/social-facebook.png";
import socialLinkedin from "../../assets/senca/social-linkedin.png";
import iconTools from "../../assets/senca/icon-tools.svg";
import iconShovel from "../../assets/senca/icon-shovel.svg";
import iconBadge from "../../assets/senca/icon-badge.svg";
import iconExcavator from "../../assets/senca/icon-excavator.svg";

export const statIconImages = {
  tools: iconTools,
  shovel: iconShovel,
  badge: iconBadge,
  excavator: iconExcavator,
};

export const projects = [
  {
    slug: "conjunto-comercial-plinio-correa",
    image: project1,
    layout: "topLeft",
    title:
      "Reforma da Sala 05 da Medicina Nuclear - Ambulatório - Bl. 3 - INCOR – HCFMUSP",
  },
  {
    slug: "galpao-industrial-sao-cristovao",
    image: project2,
    layout: "topRight",
    title: "Reforma da sala 1 – Hemodinâmica – 3º Andar – Bloco 1 – INCOR",
  },
  {
    slug: "condominio-vila-nova",
    image: project3,
    layout: "bottomLeft",
    title:
      "FACULDADE DE MEDICINA DA USP – REFORMA SALA 1357 – IMPLANTAÇÃO SALA MULTIUSO",
  },
  {
    slug: "infraestrutura-do-loteamento-jatoba",
    image: project4,
    layout: "bottomWide",
    title: "Base de Segurança - Campus USP",
  },
];

export const stats = [
  {
    id: "licitacoes",
    icon: "tools",
    lines: [{ type: "big", text: "+300" }],
    label: "PROCESSOS LICITATÓRIOS VENCIDOS",
  },
  {
    id: "hidrogenio",
    icon: "shovel",
    lines: [
      { type: "small", text: "EXECUTORA DO" },
      { type: "medium", text: "1º POSTO DE" },
      { type: "medium", text: "HIDROGÊNIO" },
      { type: "small", text: "DA AMÉRICA LATINA" },
    ],
  },
  {
    id: "funcionarios",
    icon: "badge",
    lines: [{ type: "big", text: "130" }],
    label: "FUNCIONÁRIOS EM CANTEIROS DE OBRAS EM 2023",
  },
  {
    id: "credenciada",
    icon: "excavator",
    lines: [
      { type: "title", text: "EMPRESA" },
      { type: "title", text: "CREDENCIADA" },
    ],
    label: "EM EQUIPAMENTOS DE TOMOGRAFIA GE e CANON.",
  },
];

export const socialLinks = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/",
    icon: socialInstagram,
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/",
    icon: socialFacebook,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/",
    icon: socialLinkedin,
  },
];

export const aboutParagraphs = [
  "Empresa criada em 2007 pelos sócios Carlos Augusto, engenheiro civil e Nelson Alves, administrador de empresas, este vindo da Administração Direta do Governo do Estado de São Paulo, tendo como objetivo a execução de obras e serviços, participando de processos licitatórios por todo o país.",
  "Nos primeiros anos, a empresa focou em pequenos serviços e obras, ganhando rapidamente uma reputação pela qualidade dos trabalhos e cumprimentos de prazos.",
  "Em 2010, fomos vitoriosos no processo licitatório para a execução da Manutenção Predial de todos os edifícios administrativos da CIA. DE DESENVOLVIMENTO HABITACIONAL E URBANO DO ESTADO DE SÃO PAULO – CDHU. A partir de então, a empresa SENCA executou a manutenção predial da CIA. PAULISTA DE OBRAS E SERVIÇOS – CPOS, INSTITUTO DE PESQUISAS TECNOLÓGICAS DO ESTADO DE SÃO PAULO – IPT e COMPANHIA DE PROCESSAMENTO DE DADOS DO ESTADO DE SÃO PAULO – PRODESP.",
  "Não menos importante foi a entrada da SENCA no mercado hospitalar, realizando diversas obras, como exemplo a reforma do Posto de Coleta da FUNDAÇÃO PROSANGUE no Hospital Mandaqui, diversas obras na FACULDADE DE MEDICINA DA UNIVERSIDADE DE SÃO PAULO, InCor - Instituto do Coração do Hospital das Clínicas da FMUSP, InRad – Instituto de Radiologia do Hospital das Clínicas da FMUSP, Hospital de Infectologia EMILIO RIBAS e Hospital BANDEIRANTES (LEFORT).",
  "Em 2017 foi credenciada pela empresa GE HEALTHCARE para Instalação de infra-estrutura de Ressonância Magnética e Tomógrafo e 2021 foi credenciada pela CANON MEDICAL SYSTEM DO BRASIL para a mesma finalidade.",
];

export const contactInfo = {
  phone: "(11) 2155-1665",
  phoneHref: "tel:+551121551665",
  email: "senca@senca.com.br",
  emailHref: "mailto:senca@senca.com.br",
  address: "R. Dr. Bittencourt Rodrigues - 88, Conj. 102 - São Paulo/SP",
};

export const heroImageSrc = heroImage;
export const aboutImageSrc = aboutImage;
